export class RecordBoardKeySelectorConsts {
    public static readonly FeaturedKey: string = "featured";
    public static readonly LeaderboardPersistenceKey = "leaderboardKey";
}
